'use client'
import { redirect } from 'next/navigation'
import { useEffect, useState } from 'react'
import { useGetNewsMutation } from '@/shared/api-rtk/index.js'
import { TOAST_ERROR } from '@/shared/constants/toastTypes.js'
import { IMAGE_DIR } from '@/shared/constants/linksApi'

export const MoreNews = () => {
    const navigate = (path) => redirect(path)
    const [getNews] = useGetNewsMutation()
    const [otherNews, setOtherNews] = useState([])
    const [initialCountNews, setInitialCountNews] = useState(4)
     const limitNews = initialCountNews >= otherNews.length

    useEffect(() => {
        getNews()
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setOtherNews(Object.values(res.data).reverse())
                }
            })
            .catch((err) => TOAST_ERROR('Ошибка получения других новостей'))
    }, [])

    if (!otherNews.length) {
        return <h4>Загрузка...</h4>
    }

    return (
        <div className={'MoreNews'}>
            <h2>Другие новости</h2>
            <div className={'items-container'}>
                {otherNews?.slice(0, initialCountNews).map((item, index) => {
                    const cuteTitle = item.title.replaceAll('&quot', '')
                    const imageLink = item.image
                    ? IMAGE_DIR + item.image
                    : '/bg/stub-pictures-news.png'
                    return (
                        <div
                            onClick={() => navigate('/' + item.url)}
                            key={index}
                            className={'item-card'}
                        >
                            <img onError={(e) =>
                                (e.target.src = '/bg/stub-pictures-news.png')
                            } src={imageLink} alt="" />
                            <h3>{cuteTitle}</h3>
                            <p>{item.description}</p>
                        </div>
                    )
                })}
            </div>
            {!limitNews && (
                <div className={'more-action'}>
                    <button
                        onClick={() =>
                            setInitialCountNews((state) => state + 4)
                        }
                    >
                        <img
                            src="/icons/showMore.svg"
                            alt="Иконка загрузки новых новостей"
                        />
                        <span>Показать ещё</span>
                    </button>
                </div>
            )}
        </div>
    )
}
